<template>
    <div class="speed-info">
        <div class="speed-info__driver-name">{{ driverName }}</div>
        <div
            :class="[
                'speed-info__registration-number',
                {
                    'speed-info__registration-number--online': status === 'online',
                    'speed-info__registration-number--offline': status === 'offline',
                }
            ]"
            @click="goTodaysJourney"
        >{{ registrationNumber }}</div>
    </div>
</template>

<script>
import { MEDIA_REMOTE_PLAYBACK_DEFAULT_DURATION } from '@/config/mediaConfig'
import { DeviceCommandApi } from '@/api'
import toast from '@/plugins/izitoast'
import moment from 'moment'
import router from '@/router/routes'

const deviceCommandApi = new DeviceCommandApi()

export default {
    name: 'VehicleInfoBubble',
    data () {
        return {
            address: '',
            geoCoding: null
        }
    },
    props: {
        date: {
            type: String,
            required: false
        },
        hardwareId: {
            type: String,
            required: true
        },
        latitude: {
            type: Number,
            required: true
        },
        longitude: {
            type: Number,
            required: true
        },
        registrationNumber: {
            type: String,
            required: true
        },
        driverName: {
            type: String,
            required: true
        },
        status: {
            type: String,
            required: true
        },
        hasStreamingDevice: {
            type: Boolean,
            required: false,
            default: false
        },
        id: {
            type: String,
            required: true
        }
    },
    mounted () {
        // eslint-disable-next-line no-undef
        const platform = new H.service.Platform({
            'apikey': process.env.VUE_APP_HERE_MAPS_API_KEY
        })

        // Get an instance of the search service:
        this.geoCoding = platform.getSearchService()

        this.getAddressFromLatLng()
    },
    methods: {
        async requestVideo () {
            const response = await deviceCommandApi.requestVideo({
                hardwareId: this.hardwareId,
                date: moment().format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z',
                videoLengthInSeconds: MEDIA_REMOTE_PLAYBACK_DEFAULT_DURATION * 60,
                positionMetadata: {
                    latitude: this.latitude,
                    longitude: this.longitude
                }
            })

            if (response.isSuccess) {
                toast.success('Request video send.')
            }
        },
        getAddressFromLatLng () {
            this.geoCoding.reverseGeocode({
                at: `${this.latitude},${this.longitude}`
            }, (result) => {
                result.items.forEach((item) => {
                    this.address = item.address.label
                })
            }, alert)
        },
        async goTodaysJourney () {
            //todo new redirect to journey
            return
            if ('online' === this.status) {
                router.push(`/journeys/${this.id}`)
            }
        },
        goToLivestream () {
            router.push({ path: `media/live-stream/${this.hardwareId}` })
        }
    }
}
</script>

<style scoped lang="scss">
.speed-info {
    padding: 10px 15px;
    min-width: 190px;

    &::after {
        content: '';
        background: url('../../assets/icons/icon-map-info.svg');
        width: 16px;
        height: 16px;
        display: block;
        position: absolute;
        right: 19px;
        top: 23px;
        transform: translateY(-50%);
        background-size: contain;
    }

    &__top {
        display: flex;
        justify-content: space-between;
    }

    &__text {
        line-height: 13px;
        min-width: 120px;
    }

    &__registration-number {
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        line-height: 14px;

        &--online {
            color: $success;
            cursor: pointer;
        }

        &--offline {
            color: $primary;
        }
    }

    &__driver-name {
        font-size: 12px;
        font-weight: bold;
        width: 110px;
        line-height: 14px;

        &:before {
            content: '';
            background: url('../../assets/icons/icon-driver-map-dialog.svg');
            width: 12px;
            height: 11px;
            display: inline-block;
            margin-right: 8px;
            position: relative;
            top: 1px;
        }
    }

    &__address {
        color: white;
        font-size: 10px;
        margin-bottom: 10px;
    }
    &__button {
        flex-basis: 100%;

        &--stream {
            margin-right: 10px;
        }
    }
    &__buttons {
        display: inline-flex;
        width: 100%;
    }
}
</style>
